var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemperature(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 342,
    viewBox: "0 0 216 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_240_2993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2388 67.0979L67.2388 185.582",
    stroke: "#42A0F0",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.002 96.0608L87.408 74.9968",
    stroke: "#42A0F0",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.002 96.0608L45.938 74.9968",
    stroke: "#42A0F0",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.002 159.252L87.408 180.316",
    stroke: "#42A0F0",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.002 159.252L45.938 180.316",
    stroke: "#42A0F0",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.261 97.2092L15.6506 156.451",
    stroke: "#42A0F0",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0598 111.485L121.505 118.625",
    stroke: "#42A0F0",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0596 111.485L100.77 82.7114",
    stroke: "#42A0F0",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.335 143.081L30.296 171.285",
    stroke: "#42A0F0",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3347 143.081L9.56078 135.371",
    stroke: "#42A0F0",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.695 156.451L15.0847 97.2092",
    stroke: "#42A0F0",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7302 141.764L100.769 169.969",
    stroke: "#42A0F0",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7304 141.764L121.504 134.054",
    stroke: "#42A0F0",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0054 110.169L9.56041 117.309",
    stroke: "#42A0F0",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0056 110.169L30.2956 81.395",
    stroke: "#42A0F0",
    strokeWidth: 10,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_240_2993)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_240_2993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.4003 199.055L82.4003 63C82.4003 53.7174 86.0878 44.815 92.6516 38.2513C99.2153 31.6875 108.118 28 117.4 28C126.683 28 135.585 31.6875 142.149 38.2513C148.713 44.815 152.4 53.7174 152.4 63L152.4 201.97C161.477 209.088 168.31 218.672 172.08 229.573C175.851 240.475 176.4 252.232 173.662 263.437C170.924 274.642 165.014 284.821 156.64 292.755C148.267 300.688 137.784 306.04 126.447 308.17C122.333 309.261 118.055 309.6 113.819 309.17C101.047 308.837 88.7148 304.437 78.6172 296.609C68.5196 288.781 61.1841 277.935 57.6786 265.649C54.173 253.363 54.6804 240.278 59.1269 228.301C63.5734 216.323 71.7269 206.077 82.4003 199.055Z",
    fill: "url(#paint0_linear_240_2993)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3759 249.189C56.3759 257.029 57.8886 264.644 60.8722 271.821C63.7542 278.754 67.8871 285.005 73.1563 290.402C75.7517 293.061 78.6105 295.485 81.6534 297.609C84.7227 299.75 88.0078 301.605 91.4176 303.122C98.4994 306.273 106.045 307.971 113.845 308.169L113.883 308.17L113.921 308.174C115.068 308.291 116.239 308.35 117.4 308.35C120.381 308.35 123.338 307.964 126.19 307.203L126.227 307.193L126.264 307.186C133.004 305.929 139.419 303.521 145.333 300.029C151.124 296.61 156.257 292.258 160.589 287.096C164.954 281.896 168.359 276.046 170.71 269.71C173.143 263.153 174.376 256.248 174.376 249.189C174.376 244.564 173.84 239.958 172.781 235.501C171.752 231.169 170.223 226.949 168.239 222.957C166.289 219.036 163.893 215.323 161.117 211.919C158.357 208.536 155.216 205.453 151.783 202.757L151.4 202.457V201.97L151.4 63.0001C151.4 58.4096 150.502 53.957 148.729 49.766C147.017 45.7174 144.565 42.0811 141.442 38.9583C138.319 35.8355 134.683 33.3839 130.634 31.6715C126.443 29.8988 121.991 29 117.4 29C112.81 29 108.357 29.8988 104.166 31.6715C100.118 33.3839 96.4813 35.8355 93.3585 38.9583C90.2357 42.0811 87.784 45.7174 86.0716 49.766C84.299 53.957 83.4002 58.4096 83.4002 63.0001L83.4002 199.055V199.593L82.9505 199.89C74.9469 205.164 68.2759 212.384 63.6584 220.769C61.3112 225.031 59.5004 229.575 58.2765 234.275C57.0154 239.117 56.3759 244.135 56.3759 249.189ZM55.3759 249.189C55.3759 228.231 66.1188 209.785 82.4002 199.055L82.4002 63.0001C82.4002 43.6699 98.0701 28 117.4 28C136.73 28 152.4 43.6699 152.4 63.0001L152.4 201.97C166.389 212.955 175.376 230.023 175.376 249.189C175.376 278.543 154.296 302.975 126.447 308.169C123.561 308.94 120.529 309.35 117.4 309.35C116.191 309.35 114.997 309.289 113.82 309.169C81.401 308.344 55.3759 281.806 55.3759 249.189Z",
    fill: "white",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.5024 250.552C71.5006 242.089 73.8334 233.79 78.2442 226.567C82.655 219.344 88.9728 213.479 96.5024 209.615V159.552H138.502V209.614C145.772 213.344 151.917 218.943 156.305 225.836C160.694 232.728 163.167 240.665 163.471 248.83C163.774 256.995 161.898 265.094 158.034 272.293C154.17 279.493 148.459 285.533 141.486 289.793C134.514 294.054 126.533 296.38 118.364 296.533C110.194 296.686 102.132 294.66 95.0047 290.664C87.8778 286.668 81.944 280.845 77.8134 273.795C73.6827 266.746 71.5044 258.723 71.5024 250.552Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_240_2993",
    x: 0.559082,
    y: 58.0979,
    width: 129.947,
    height: 136.484,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_240_2993"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_240_2993",
    x: 51.3755,
    y: 24,
    width: 128.002,
    height: 289.351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_240_2993"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_240_2993",
    x: 35.3755,
    y: 0,
    width: 180.002,
    height: 341.351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 0.501961 0 0 0 0 0.501961 0 0 0 0.302 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_240_2993"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_240_2993",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_240_2993",
    x1: 160.257,
    y1: 141.947,
    x2: 42.2076,
    y2: 169.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.596
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7",
    stopOpacity: 0.204
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.c622bbae7dad45b06505b0e691c3aa64.svg";
export { ForwardRef as ReactComponent };